import { connect } from 'react-redux';
import { RootState } from 'typesafe-actions'
import { resetPasswordEmailAsyncThunk } from '../actions/AuthActions'
import { ThunkDispatch } from 'redux-thunk';
import { RouteComponentProps, withRouter } from 'react-router';
import ResetPassword from '../components/ResetPassword';

interface DispatchProps {
  resetPassword: (email: string) => void
}

const mapStateToProps = (state: RootState) => {
  return ({
    resetPasswordMessage: state.authRdc.passwordResetEmailSendMessage,
    passwordResetSuccess: state.authRdc.passwordResetEmailSendSuccess
  })
};

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>): DispatchProps => {
  return {
    resetPassword: async (email: string) => {
      await dispatch(resetPasswordEmailAsyncThunk(email))
    }
  }
}

export type ResetPasswordProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & RouteComponentProps

const ResetPasswordCnn = connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPassword);

export default withRouter(ResetPasswordCnn)